import type { Board } from "../../board";
import { isRemoteDoor, PRIORITY_LAST, type ProcessableThing } from "../../interfaces";
import { PhysicalThing } from "../../physicalThing";
import { deserializeXY } from "../../serialization";
import { Sound } from "../sounds/sound";
import { SoundId } from "../sounds/soundId";
import type { XY } from "../../xy";

export class OpenBlastDoorsTrap extends PhysicalThing implements ProcessableThing {
	static key = "OpenBlastDoorsTrap";
	constructor(xy: XY) {
		super(xy, false);
	}

	isVisible(): boolean {
		return false;
	}

	processTurn(board: Board): void {
		if (!board.player) return;
		const dist = this.xy.distanceTo(board.player.xy);
		if (dist > 3) return;

		for (const thing of board.getPhysicalThings()) {
			if (thing.xy.distanceTo(this.xy) <= 5 && isRemoteDoor(thing)) {
				thing.open();
			}
		}
		board.addNonPhysicalThing(new Sound(SoundId.ROBOT_BASE_ALARM, this.xy));
		board.removeAtEndOfTurn(this);
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	static deserialize(data: any): OpenBlastDoorsTrap {
		const t = new OpenBlastDoorsTrap(deserializeXY(data.xy));
		t.visualId = data.visualId;
		return t;
	}
}
